import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IParticipant } from 'src/app/storage/interfaces/participant.interface';
import { environment } from 'src/environments/environment';

const URL = environment.aws.amplify.API.REST;

@Injectable({
  providedIn: 'root'
})
export class ParticipantsService  {
    participants$: BehaviorSubject<IParticipant[]> = new BehaviorSubject<IParticipant[]>([]);

    constructor(private _http: HttpClient) { }

    async findAllByMissionId(missionId: string) {
        try {
            const response = await this._http.get(`${URL}participants/missions/${missionId}`).toPromise();
            if (response !== null) {
                this.participants$.next(response['participants']);
            }
        } catch (err) {
            console.error(err);
        }
    }

    async insertParticipant(participant: IParticipant, missionId: string) {
        return await this._http.post(encodeURI(`${URL}participants/missions/${missionId}`), participant).toPromise();
    }
}